// extracted by mini-css-extract-plugin
module.exports = {"iconWrapper":"Icon_iconWrapper__1aYRL","svg":"Icon_svg__3DuJi"};